const DISPLAY_FONTS_URL = [
  'https://fonts.googleapis.com/css2?',
  'family=Agbalumo',
  '&family=Agdasima:wght@400;700',
  '&family=Aguafina+Script',
  '&family=Alumni+Sans+Collegiate+One',
  '&family=Annie+Use+Your+Telescope',
  '&family=Anta',
  '&family=Anton',
  '&family=Anton+SC',
  '&family=Bangers',
  '&family=Bebas+Neue',
  '&family=Bhavuka',
  '&family=Briem+Hand',
  '&family=DM+Sans:wght@400;700',
  '&family=DM+Serif+Display',
  '&family=Gochi+Hand',
  '&family=Inter:wght@400;700',
  '&family=Montserrat:wght@400;700',
  '&family=Oswald:wght@400;700',
  '&family=Pixelify+Sans:wght@400;700',
  '&family=Roboto+Condensed:wght@400;700',
  '&family=Sumana:wght@400;700',
  '&display=swap',
].join('')

export function DisplayFontsLoader() {
  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link rel="stylesheet" href={DISPLAY_FONTS_URL} />
    </>
  )
}
